import { ChangeDetectorRef, Directive, ElementRef, Input, AfterViewInit, OnChanges } from '@angular/core'

@Directive({ selector: '[buttonSpinner]' })
export class ButtonSpinnerDirective implements AfterViewInit, OnChanges {
  @Input() buttonSpinner!: boolean
  @Input() disabled!: boolean

  initialButtonHtml: any
  button: any
  buttonLabel: any
  spinnerHtml = `
    <img
      src="/assets/icons/loading-dark.svg"
      alt="loading"
      class="icon-spinner"
      height="25"
      width="24" />
  `

  constructor(
    private elementRef: ElementRef,
    private cdr: ChangeDetectorRef
  ) {}

  ngAfterViewInit() {
    this.setElements()
  }

  ngOnChanges() {
    if (!this.button || !this.buttonLabel || !this.initialButtonHtml) this.setElements()

    if (this.button) this.button.disabled = this.disabled || !!this.buttonSpinner

    if (this.buttonLabel && this.initialButtonHtml)
      this.buttonLabel.innerHTML = this.buttonSpinner ? this.spinnerHtml : this.initialButtonHtml

    this.cdr.detectChanges()
  }

  setElements() {
    this.button = this.elementRef.nativeElement
    this.buttonLabel = this.button.querySelector('.mdc-button__label') || this.button
    if (this.buttonSpinner) this.initialButtonHtml = this.buttonLabel?.innerHTML
  }
}
